<template>
        <div id="graph">
            <canvas id="arbitrageChart" width="1280" height="768"></canvas>
        </div>
       
</template>
<script>
    import axios from 'axios';
    export default {       

        props: {
            portfolioguid: String           
        },
        data: function () {
            return {
                portfolioGuid: this.portfolioguid             
            };
        },
        methods: {
            async getYearlyProfits() {
                

                const { data } = await axios.get('/arbitrage/GetArbitrage', {
                    params: {
                        count: 10000
                    }
                });

                var ir = data.filter(item => item.exchangeCode === "IR");
                var cs = data.filter(item => item.exchangeCode === "CS");
                var bn = data.filter(item => item.exchangeCode === "BN");
                var ds = data.filter(item => item.exchangeCode === "DS");

                var planetChartData = {
                    type: 'line',
                    data: {
                        labels: ir.map(value => value.createDate),
                        datasets: [
                            { // one line graph
                                label: 'IR',
                                data: ir.map(value => value.sellPrice),
                                //backgroundColor: ir.map(value => value.sellPrice < 0 ? 'rgba(255, 0, 0, 0.5)' : 'rgba(54,73,93,.5)'),
                                borderColor: '#9a0e35',
                                borderWidth: 0.5,
                                pointStyle: 'line'

                            },
                            { // one line graph
                                label: 'CS',
                                data: cs.map(value => value.sellPrice),
                                //backgroundColor: ir.map(value => value.sellPrice < 0 ? 'rgba(255, 0, 0, 0.5)' : 'rgba(54,73,93,.5)'),
                                borderColor: '#36495d',
                                borderWidth: 0.5,
                                pointStyle: 'line'

                            },
                            { // one line graph
                                label: 'BN',
                                data: bn.map(value => value.sellPrice),
                                //backgroundColor: ir.map(value => value.sellPrice < 0 ? 'rgba(255, 0, 0, 0.5)' : 'rgba(54,73,93,.5)'),
                                borderColor: 'pink',
                                borderWidth: 0.5,
                                pointStyle: 'line'

                            },
                            { // one line graph
                                label: 'DS',
                                data: ds.map(value => value.sellPrice),
                                //backgroundColor: ir.map(value => value.sellPrice < 0 ? 'rgba(255, 0, 0, 0.5)' : 'rgba(54,73,93,.5)'),
                                borderColor: 'green',
                                borderWidth: 0.5,
                                pointStyle: 'line'

                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    padding: 25,
                                }
                            }]
                        },
                        plugins: {
                            zoom: {
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true
                                    },
                                    mode: 'xy',
                                }
                            }
                        }
                    }
                }

                this.createChart('arbitrageChart', planetChartData);
            }
        },
        async mounted() {
            await this.getYearlyProfits();
        }
    }
</script>